import React, { useEffect } from 'react';
import styles from '../styles/Toast.module.css';

export interface ToastProps {
    message: string;
    type: 'success' | 'error';
    isVisible: boolean;
    onClose: () => void;
    duration?: number;
}

const Toast: React.FC<ToastProps> = ({
    message,
    type,
    isVisible,
    onClose,
    duration = 5000
}) => {
    useEffect(() => {
        if (isVisible && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [isVisible, duration, onClose]);

    if (!isVisible) return null;

    return (
        <div className={`${styles.toast} ${styles[type]} ${styles.isVisible}`}>
            <div className={styles.toastContent}>
                <span className={styles.toastIcon}>
                    {type === 'success' ? '🎵' : '❌'}
                </span>
                <span className={styles.toastMessage}>{message}</span>
                <button
                    onClick={onClose}
                    className={styles.toastClose}
                    aria-label="Close notification"
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default Toast;